const getTextAsFormattedString = (text: any) => {
  const formattedText = (text as string).replace('\n', '<br />')
  return formattedText
}

export default getTextAsFormattedString
